import { Playground, Props } from 'docz';
import { UploadFile } from '@cosmotech/ui';
import { UPLOAD_FILE_STATUS_KEY } from "../../../../../../src/inputs/UploadFile/StatusConstants.js";
import * as React from 'react';
export default {
  Playground,
  Props,
  UploadFile,
  UPLOAD_FILE_STATUS_KEY,
  React
};